import { LinkVideo, Video } from '@/components/Video'
import Layout from '@/components/Layout'
import Head from 'next/head'
import Loader from '@/components/Loader'

const Home = () => {
  return (
    <>
    <Head>
    <title>Athena Mercury | New Age Couture</title>
        <meta name='description' content="As a brand, ATHENA MERCURY embodies outlandish, lavish couture/ready to wear fashion. Acting as a platform that aims to empower and sexualise women, through challenging the plethora of barriers and stereotypes surrounding femininity and gender. Mercury's one off made to measure pieces are made in London with love and motivated by women's rights. Combining design and activism, to encourage women to come together and grow together."/>
        <meta property="twitter:image" content="../public/icon.png" />
        <meta property="og:image" content="../public/icon.png" />
        <meta property="twitter:description" content="As a brand, ATHENA MERCURY embodies outlandish, lavish couture/ready to wear fashion. Acting as a platform that aims to empower and sexualise women, through challenging the plethora of barriers and stereotypes surrounding femininity and gender. Mercury's one off made to measure pieces are made in London with love and motivated by women's rights. Combining design and activism, to encourage women to come together and grow together." />
        <meta property="og:description" content="As a brand, ATHENA MERCURY embodies outlandish, lavish couture/ready to wear fashion. Acting as a platform that aims to empower and sexualise women, through challenging the plethora of barriers and stereotypes surrounding femininity and gender. Mercury's one off made to measure pieces are made in London with love and motivated by women's rights. Combining design and activism, to encourage women to come together and grow together." />
        <meta property="twitter:title" content="Athena Mercury | New Age Couture" />
        <meta property="og:title" content="Athena Mercury | New Age Couture" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="og:url" content="https://athenamercury.com/" />
    </Head>
    <Loader />
    <main>
      <Layout
      className='space-y-10 desktop:space-y-16'
      >
      <div className='py-5 space-y-8 flex flex-col items-center justify-center'>
        <p className='font-bold text-center text-lg mobile:text-xl tablet:text-3xl'>
          WHO ARE WE?
        </p>
        <p className='font-bold text-center text-base mobile:text-lg tablet:text-2xl'>
          Statements About Society
        </p>
        <hr className='mx-auto bg-black h-0.5 w-1/2 m-5 desktop:mb-10'/>
        <p className='text-center para-text font-text'>
          As a brand ATHENA MERCURY embodies outlandish, lavish couture and ready to 
          wear fashion. Acting as a platform that aims to <strong>empower and sexualise 
          women, through challenging the plethora of barriers and stereotypes surrounding
          femininity and gender. </strong>Mercury&apos;s one off made to measure 
          pieces are constructed in London with love and motivated by <strong>women&apos;s 
          rights. </strong>Combining design and activism, to encourage women to come 
          together and grow together.</p> 
      </div>
      <Video 
      href="https://res.cloudinary.com/dxrtssxet/video/upload/v1682176433/Athena%20Mercury/Athena%20Mercury%20-%20Videos/ABOUT_SECTION_NEW_SIZE_compressed_video_20230422_144355_qvu32o.mp4"
      />
      <div className='space-y-10 desktop:space-y-16 pt-5 para-text flex flex-col items-center justify-center'>
        <p className='para-text text-center font-text'>Working towards addressing all 
        <strong> global or political issues surrounding the definition of &apos;WOMAN&apos;. </strong>  
        These Conceptual couture pieces <strong>provoke necessary discussions surrounding what 
          it means to be a woman in our society,</strong> aiding awareness and progress within 
          the movement. As a brand, we pride ourselves in highlighting global political and 
          social issues through the art of fashion.</p>
        <p className='para-text text-center font-text'>With each collection offering ready-to-wear 
        and one-of-a-kind couture garments to adorn your personal definition of femininity. 
        Encouraging you to express every facet of your gender identity and create your own personal 
        agency. <strong>ATHENA MERCURY&apos;S pieces are available to rent, purchase or bring your 
          creative vision to life through our commission work. This included a design consultation 
          and fit</strong> sessions running up to the final finished product.</p>
      </div>
      <div className='space-y-10 py-5'>
        <p className='font-bold text-center text-lg mobile:text-xl tablet:text-3xl'>COALITION OF WOMEN</p>
        <hr className='mx-auto bg-black h-0.5 w-1/2 m-5 desktop:mb-10'/>
        <p className='para-text text-center font-text'>As a brand we are commitment to social sustainability. This includes our profit percentage charity work, activism and provoking new ways of thinking.</p>
        <p className='para-text text-center font-text'>ATHENA MERCURY recognises women are individually strong and even <strong>stronger together.</strong>  We celebrate <strong>uniting</strong> every kind of women. Join us and take part in the campaigns organised by Action Aid and Refuge, alongside many others, and become part of the new age equality network. </p>
      </div>
      <hr className='mx-auto bg-black h-0.5 w-1/2 m-5 mb-10'/>
      <LinkVideo 
      href="https://res.cloudinary.com/dxrtssxet/video/upload/v1682176436/Athena%20Mercury/Athena%20Mercury%20-%20Videos/JUMPSUIT_NEW_SIZE_compressed_video_20230422_150926_cqisbz.mp4"
      title="portfolio"
      link="/portfolio"
      />
      </Layout>
    </main>
    </>
  )
}

export default Home